import { StyledIconLarge } from "../StyledIcon/StyledIcon";
import { CardH1, CardText } from "../../styles/Typography";
import { StyledCard, StyledIconContainer } from "./Card.styles";

interface CardProps {
  icon?: any;
  title?: string;
  header?: string;
  /** делает карточку кликабельной — например, для фильтрации таблицы */
  onClick?: () => void;
  /** карточка подсвечена как выбранный фильтр */
  active?: boolean;
}

const Card: React.FC<CardProps> = ({
  icon,
  title,
  header,
  onClick,
  active,
}) => {
  const clickable = !!onClick;

  return (
    <StyledCard
      $clickable={clickable}
      $active={!!active}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-pressed={clickable ? !!active : undefined}
      onKeyDown={
        clickable
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick!();
              }
            }
          : undefined
      }
    >
      <StyledIconContainer>
        <StyledIconLarge icon={icon} />
      </StyledIconContainer>
      <CardH1>{header}</CardH1>
      <CardText>{title}</CardText>
    </StyledCard>
  );
};

export default Card;
